import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';

import './style.css'; // Import the CSS file

type SpinnerProps = { hasText?: boolean; text?: string };

const Spinner: React.FC<SpinnerProps> = ({ hasText = true, text = '' }) => {
  const { t } = useTranslation();

  return (
    <div className={'spinnerWrapper spinner-instance'}>
      {/* A ring that turns (CSS only): the old animated image also turned itself, slightly off-centre, and wobbled */}
      <div className='spinner' role='progressbar' aria-label={t('main.loading')} />
      {hasText && (
        <Typography variant='body1' component='h4' style={{ color: '#00A98C' }}>
          {t('main.loading')}
        </Typography>
      )}
    </div>
  );
};

export default Spinner;
